import React, { useState, useEffect } from 'react';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
import { TabBar, TabsMaster, SearchAdminProgramRequests } from '../../../components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UrlEnum } from '../../../shared';
import { academicProgramsService } from '../../../services';
import { RequestNav } from '../../../components/academic-affair-program-requests/components/program-requests-requestNav';
import { RequestDetails } from '../../../components/academic-affair-program-requests/components/program-requests-RequestDetails';
import { RequestLogHistory } from '../../../components/academic-affair-program-requests/components/admin/program-requests-RequestLogs';
import { InstitutionRequestLogHistory } from '../../../components/academic-affair-program-requests/components/institution/program-requests-institution-RequestLogs';
import eventEmitter from "../../../shared/eventEmitter";

export const ProgramRequestInstitutionViewPage = props => {
    const [programRequestLogData, setProgramRequestLogData] = useState([]);
    const [currentRequestData, setCurrentRequestData] = useState([]);
    const [requestStatus, setRequestStatus] = useState([]);
    const [requestId, setRequestId] = useState(-1);
    useEffect(() => {
        const parseQueryParams = () => {
            const query = props.location.state;
            console.log(query);
            if (query) {
                for (let param of query) {
                    setCurrentRequestData(param.data);
                    setRequestId(param.data.requestID);
                }
            }
        };
        parseQueryParams();
    }, [props.location.state]);

    useEffect(() => {
        const res = academicProgramsService.getProgramRequestLogs(requestId);
        Promise.resolve(res).then(data => {
            setProgramRequestLogData(data ?? []);
        });
    }, [requestId]);

    useEffect(() => {
        const handleDataUpdate = async () => {
            const res = academicProgramsService.getProgramRequestLogs(requestId);
            Promise.resolve(res).then(data => {
                setProgramRequestLogData(data ?? []);
            });
        };
        eventEmitter.on('updateSARData', handleDataUpdate);
        return () => {
            eventEmitter.off('updateSARData', handleDataUpdate);
        };
    }, []);
    return (
        <div>
            <div className="program-request-details">
                <RequestDetails
                    requestDetails={currentRequestData}
                    setRequestDetails={setCurrentRequestData}
                    showBackButton={true}
                />

                <InstitutionRequestLogHistory
                    requestLogs={programRequestLogData}
                    requestStatus={currentRequestData.status}
                />
            </div>
        </div>
    );
};
